import React from "react";
import styled from "styled-components";
import Container from "../../Container";
import ProductDesign from "./ProductDesign";
import DesignSystems from "./DesignSystem";
import Technology from "./Technology";
import CodeReminders from "./CodeReminders";
import AI from "./AI";

const LeftAligned = styled.div`
  text-align: left;
`;

const CaseStudiesContainer = styled(Container)`
  max-width: 124rem;
  width: 100%;
  padding-top: var(--spacing-clear);
  @media (min-width: 1024px) {
    padding-top: var(--spacing-x-large);
  }
`;

const ScrollToSection = styled.div`
  margin-bottom: var(--spacing-x-large);
`;

const Grid = styled.div`
  padding: var(--spacing-large);
  @media (min-width: 1024px) {
    display: grid;
    grid-template-columns: 160px 1fr;
    grid-gap: var(--spacing-x-large);
    padding: var(--spacing-large);
    padding-top: var(--spacing-small);
  }
`;

const Aside = styled.aside`
  display: none;
  @media (min-width: 1024px) {
    display: block;
  }
  padding-top: var(--spacing-x-large);
  text-align: left;
  a {
    display: block;
    margin-bottom: var(--spacing-small);
  }
`;

const AsideSticky = styled.div`
  position: sticky;
  top: var(--spacing-x-medium);
`;

const BlogSectionVerticalSpace = styled.section`
  margin-bottom: var(--spacing-large);
`;

const StyledLinkButton = styled.a`
  color: #ff73df;
  text-decoration: none;
  &:hover,
  &:focus {
    color: #ff89e4;
  }
`;

const LevelTwoNav = styled.a`
  color: #ff73df;
  text-decoration: none;
  font-size: 14px;
  color: white;
  &:hover,
  &:focus {
    color: #ff89e4;
    cursor: pointer;
  }
`;

const CaseStudies = () => {
  return (
    <Grid>
      <Aside>
        <AsideSticky>
          <StyledLinkButton href="#designsystems">Design Systems</StyledLinkButton>
          <LevelTwoNav href="#adoption" style={{ marginBottom: 4 }}>
            <span style={{ opacity: 0.4, marginRight: 4 }}>»</span> Adoption
          </LevelTwoNav>
          <LevelTwoNav href="#maturefeelix" style={{ marginBottom: 4 }}>
            <span style={{ opacity: 0.4, marginRight: 4 }}>»</span> Maturing Feelix
          </LevelTwoNav>
          <LevelTwoNav href="#muibook" style={{ marginBottom: 4 }}>
            <span style={{ opacity: 0.4, marginRight: 4 }}>»</span> Muibook
          </LevelTwoNav>
          <LevelTwoNav href="#outcomes" style={{ marginBottom: 4 }}>
            <span style={{ opacity: 0.4, marginRight: 4 }}>»</span> Outcomes
          </LevelTwoNav>
          <LevelTwoNav href="#guidelines" style={{ marginBottom: 4 }}>
            <span style={{ opacity: 0.4, marginRight: 4 }}>»</span> Guidelines
          </LevelTwoNav>
          <LevelTwoNav href="#roadmap" style={{ marginBottom: 4 }}>
            <span style={{ opacity: 0.4, marginRight: 4 }}>»</span> Roadmap
          </LevelTwoNav>
          <LevelTwoNav href="#designtokens" style={{ marginBottom: 4 }}>
            <span style={{ opacity: 0.4, marginRight: 4 }}>»</span> Design Tokens
          </LevelTwoNav>
          <LevelTwoNav href="#contribution" style={{ marginBottom: 4 }}>
            <span style={{ opacity: 0.4, marginRight: 4 }}>»</span> Contribution Models
          </LevelTwoNav>
          <LevelTwoNav href="#buildvsbuy" style={{ marginBottom: 4 }}>
            <span style={{ opacity: 0.4, marginRight: 4 }}>»</span> Build vs Buy
          </LevelTwoNav>
          <LevelTwoNav href="#typography" style={{ marginBottom: 36 }}>
            <span style={{ opacity: 0.4, marginRight: 4 }}>»</span> Typography
          </LevelTwoNav>
          {/* <LevelTwoNav href="#reduceconfusion" style={{ marginBottom: 36 }}>
            <span style={{ opacity: 0.4, marginRight: 4 }}>»</span> Collaboration
          </LevelTwoNav> */}
          <StyledLinkButton href="#ai">AI / Tooling</StyledLinkButton>
          <LevelTwoNav href="#redactd" style={{ marginBottom: 4 }}>
            <span style={{ opacity: 0.4, marginRight: 4 }}>»</span> Redactd™
          </LevelTwoNav>
          <LevelTwoNav href="#orgagent" style={{ marginBottom: 4 }}>
            <span style={{ opacity: 0.4, marginRight: 4 }}>»</span> Org Agent
          </LevelTwoNav>
          <LevelTwoNav href="#muiplay" style={{ marginBottom: 36 }}>
            <span style={{ opacity: 0.4, marginRight: 4 }}>»</span> Muiplay
          </LevelTwoNav>
          <StyledLinkButton href="#productdesign">Product Design</StyledLinkButton>
          <LevelTwoNav href="#dumpty" style={{ marginBottom: 4 }}>
            <span style={{ opacity: 0.4, marginRight: 4 }}>»</span> Dumpty
          </LevelTwoNav>
          <LevelTwoNav href="#expenses" style={{ marginBottom: 4 }}>
            <span style={{ opacity: 0.4, marginRight: 4 }}>»</span> Expenses
          </LevelTwoNav>
          <LevelTwoNav href="#designsprint" style={{ marginBottom: 4 }}>
            <span style={{ opacity: 0.4, marginRight: 4 }}>»</span> Design Sprint
          </LevelTwoNav>
          <LevelTwoNav href="#research" style={{ marginBottom: 4 }}>
            <span style={{ opacity: 0.4, marginRight: 4 }}>»</span> User Research
          </LevelTwoNav>
          <LevelTwoNav href="#storytelling" style={{ marginBottom: 36 }}>
            <span style={{ opacity: 0.4, marginRight: 4 }}>»</span> Storytelling
          </LevelTwoNav>

          <StyledLinkButton href="#technology">Technology</StyledLinkButton>
          <StyledLinkButton href="#codereminder">Code Reminders</StyledLinkButton>
        </AsideSticky>
      </Aside>
      <CaseStudiesContainer large center>
        <LeftAligned>
          <BlogSectionVerticalSpace>
            <ScrollToSection id="designsystems">
              <DesignSystems />
            </ScrollToSection>
            <ScrollToSection id="ai">
              <AI />
            </ScrollToSection>
            <ScrollToSection id="productdesign">
              <ProductDesign />
            </ScrollToSection>
            <ScrollToSection id="technology">
              <Technology />
            </ScrollToSection>
            <ScrollToSection id="codereminder">
              <CodeReminders />
            </ScrollToSection>
          </BlogSectionVerticalSpace>
        </LeftAligned>
      </CaseStudiesContainer>
    </Grid>
  );
};

export default CaseStudies;
